import * as React from "react";
const Plugin = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19.35 9.16a.48.48 0 00-.7 0l-3.16 3.16-3.82-3.82 3.13-3.13a.502.502 0 10-.71-.71L11 7.79 9 5.85l-1 1-1.61 1.64a6.442 6.442 0 009.11 9.11l2.63-2.6-1.94-2 3.16-3.16a.5.5 0 000-.68zM7.09 16.89a5.45 5.45 0 010-7.68l7.7 7.69a5.45 5.45 0 01-7.7-.01zm9.34-1.63l-.94.94-7.7-7.7L9 7.27l7.7 7.7-.27.29z" }));
Plugin.displayName = "Plugin";
var Plugin_default = Plugin;
export {
  Plugin_default as default
};
